module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v(_vm._s(_vm.$t('title.' + _vm.action + '.owner')))]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 40
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('data-form', {
    attrs: {
      "model": "owners",
      "entity": _vm.owner,
      "fields": _vm.fields,
      "before-submit": _vm.beforeSubmit,
      "after-submit": _vm.afterSubmit
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('related-organizations')))]), _vm._v(" "), _c('data-table', {
    attrs: {
      "model": "organizations",
      "columns": ['name', 'id'],
      "isSelected": _vm.isOrganizationSelected
    },
    on: {
      "selection-change": _vm.organizationSelectChanged
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-34bf5358!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/owner/OwnerDetails.vue
// module id = 988
// module chunks = 2